// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3UdBn","newExpiryDate":"styles_newExpiryDate__2BRbI","footer":"styles_footer__3nLI5"};